const isScrolledIntoView = (el) => {
  var rect = el.getBoundingClientRect();
  var elemTop = rect.top;
  var elemBottom = rect.bottom;
  isVisible = elemTop < (window.innerHeight - 150) && elemBottom >= 0;
  return isVisible;
}

const animateFeaturedCollection = () => {
  document.querySelectorAll('.section-featured-collection').forEach((collectionEl) => {
    collectionEl.querySelectorAll('.grid__item').forEach((item) => {
      if (isScrolledIntoView(item)) {
        if (item.getAttribute('data-passed') != 'true') {
          item.classList.add('animation-enabled');
          item.setAttribute('data-passed', true);
        }
      }
    })
  })
}

window.addEventListener("DOMContentLoaded", (event) => {
  document.addEventListener('scroll', (e) => {
    animateFeaturedCollection();
  })
});

// animateFeaturedCollection();

document.querySelectorAll('[data-slider-container]').forEach((slider) => {
  if (window.innerWidth > 768) {
    var flkty = new Flickity(slider, {
      cellAlign: "left",
      wrapAround: true,
      pageDots: false,
      resize: true
    });
  }
})

// START: This code is to update Product Card Discount Code after swatch change
window.addEventListener("DOMContentLoaded", (event) => {
  if (discountCodeSettings?.discountCodeEnabled) {
    document.addEventListener("variant:change", function (e) {
      updateProductPrice(e.detail.variant)
    })
    discountCodeFunctionality();
  }

  function discountCodeFunctionality() {
    document.addEventListener('click', (e) => {
      const swatchClicked = e.target.closest(".swatch-view-item");
      if (swatchClicked) {
        var productCard = e.target.closest(".js--swatches-main.grid-product[data-product-id]");
        const handle = swatchClicked.querySelector(".swatch-custom-image")?.getAttribute("swatch-url").split("/").at(-1);
        console.log("handle: ", handle);
        if(handle) {
          setTimeout(() => fetchDiscountedPrice(handle, productCard), 100);
        }
      }
    }, true)

    function fetchDiscountedPrice(handle, targetDiv) {
      let url = `/products/${handle}?section_id=product-price-ajax`;
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const priceContainer = targetDiv.querySelector(".grid-product__price[data-pid]");
          const newPrice = doc.querySelector('#shopify-section-product-price-ajax');
          if (priceContainer && newPrice && newPrice.innerHTML.length > 0) {
            priceContainer.innerHTML = "";
            priceContainer.innerHTML = newPrice.innerHTML;
          }
        }).catch((error) => {
          console.error('Error fetching discounted price:', error);
        });
    }
  }

  function updateProductPrice(variant) {
    if(variant.inventory_quantity > 0 && variant.compare_at_price == null && !productMetafield ) {
      const productPriceTarget = document.querySelector(".product-block--price.product__price");
      productPriceTarget.innerHTML="";
      let variantPrice = variant.price;

      let discountAmount = (variantPrice * discountCodeSettings.generalDiscountCodePercentage) / 100;
      let discountedPrice = variantPrice - discountAmount;  
      const discountCodeTemplate = 
      `<span data-product-price="" class="product__price123">
        <span style="text-decoration: line-through;margin-right: 5px; ">${theme.Currency.formatMoney(variantPrice, theme.settings.moneyFormat)}</span>  
        <span style="color: #833f4a;">${theme.Currency.formatMoney(discountedPrice, theme.settings.moneyFormat)}</span>
        <div class="product-discount-text">
          ${theme.Currency.formatMoney(discountedPrice, theme.settings.moneyFormat)}
          ${discountCodeSettings.pdpDiscountText}
          ${discountCodeSettings.generalDiscountCode}
         </div>
      </span>`;
      productPriceTarget.insertAdjacentHTML('beforeend', discountCodeTemplate);
    }
  }
})
// END: This code is to update Product Card Discount Code after swatch change

//Start: This code is to add a body overlay when modal is open
document.addEventListener('modalOpen', (e) => {
  const scrollbarWidth = getScrollbarWidth();
  addBodyOverlay(scrollbarWidth);
  const header = document.querySelector('#StickyHeaderWrap .site-header--stuck');
  if (header) {
    header.style.right = `${scrollbarWidth}px`;
  }
});

document.addEventListener('modalClose', (e) => {
  removeBodyOverlay();
  const header = document.querySelector('#StickyHeaderWrap .site-header--stuck');
  if (header) {
    header.style.right = 0;
  }
});

function addBodyOverlay(scrollbarWidth) {
  document.body.style.overflow = 'hidden';
  document.body.style.paddingRight = `${scrollbarWidth}px`;
}

function removeBodyOverlay() {
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
}

// START: This code is to make body overflow hidden and add padding right to fix cls issue
function getScrollbarWidth() {
  // Create a temporary element to measure scrollbar width
  const scrollDiv = document.createElement('div');
  scrollDiv.style.visibility = 'hidden';
  scrollDiv.style.overflow = 'scroll';  // Force scrollbar to appear
  scrollDiv.style.width = '50px';      // Fixed width
  scrollDiv.style.position = 'absolute';
  // Append the div to the body and measure the scrollbar width
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);

  return scrollbarWidth;
}
//End: This code is to add a body overlay when modal is open 


// This code is only for Swym Page
// This code integrates Swym's "Add to Cart" functionality with our site's cart system 
document.addEventListener('DOMContentLoaded', () => {
  // When an item is added to cart via Swym, dispatch our custom event
  const handleAddToCart = () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  };

  // Initialize Swym event listener once the Swym library is loaded
  const initializeSwymListener = () => {
    // Check if Swym is loaded (window._swat exists)
    if (window._swat) {
      // Add listener for Swym's add to cart event
      _swat.evtLayer.addEventListener("sw:addedtocart", handleAddToCart);
      return;
    }
    
    // If Swym isn't loaded yet, try again in 500ms
    setTimeout(initializeSwymListener, 500);
  };

  // Start the initialization process
  initializeSwymListener();
});

document.addEventListener('drawerOpen', function() {
  console.log("drawer opening");
  const scrollbarWidth = getScrollbarWidth();
  document.body.style.overflow = 'hidden';
  document.body.style.paddingRight = `${scrollbarWidth}px`;

  const header = document.querySelector('#StickyHeaderWrap .site-header--stuck');
  if (header) {
    header.style.right = `${scrollbarWidth}px`;
  }
});

document.addEventListener('drawerClose', function() {
  console.log("drawer closing");
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';  // Remove the added padding
  const header = document.querySelector('#StickyHeaderWrap .site-header--stuck');
  if (header) {
    header.style.right = 0;
  }
});
// END: This code is to make body overflow hidden and add padding right to fix cls issue
